<template>
  <div>
    <!-- Description -->
    <v-subheader v-if="showDescription && notice.description">Descripción</v-subheader>
    <v-layout row wrap justify-center v-if="showDescription && notice.description">
      <v-flex xs11>
        <p
          class="description"
          v-for="(paragraph, key) in notice.description.split('\n')"
          :key="key"
        >{{ paragraph }}</p>
      </v-flex>
    </v-layout>
    <!-- Description -->

    <!-- Type -->
    <v-list-tile avatar>
      <v-list-tile-avatar>
        <img v-if="notice.type == 'A'" :src="require('@/assets/notices/aviso.png')" />
        <img v-else-if="notice.type == 'E'" :src="require('@/assets/notices/evento.png')" />
        <img v-else-if="notice.type == 'R'" :src="require('@/assets/notices/informe.png')" />
        <img v-else-if="notice.type == 'P'" :src="require('@/assets/notices/permiso.png')" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>Tipo</v-list-tile-title>
        <v-list-tile-sub-title>{{ notice.type | noticeTypeFilter }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <!-- Type -->

    <!-- Confirm -->
    <v-list-tile avatar>
      <v-list-tile-avatar>
        <v-icon v-if="notice.confirm == 'A'" color="green" large>check</v-icon>
        <v-icon v-else-if="notice.confirm == 'P'" large>more_horiz</v-icon>
        <v-icon v-else large color="red">cancel</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>Estado</v-list-tile-title>
        <v-list-tile-sub-title>{{ notice.confirm | confirmFilter }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <!-- Confirm -->

    <!-- Date -->
    <v-list-tile avatar>
      <v-list-tile-avatar>
        <img :src="require('@/assets/notices/SKLB-Evento.png')" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>Fecha de creación</v-list-tile-title>
        <v-list-tile-sub-title>{{ notice.createdAt | dateFormat }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <!-- Date -->

    <!-- Publisher -->
    <v-subheader>Creador</v-subheader>
    <v-list-tile avatar>
      <v-list-tile-avatar>
        <img
          v-if="notice.employee.img != null && notice.employee.img != ''"
          :src="'data:image/jpg;base64, ' + notice.employee.img"
        />
        <v-icon v-else color="gray lighten-4">person</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title
          v-if="notice.employee"
        >{{ notice.employee.firstName + ' ' + notice.employee.lastName}}</v-list-tile-title>
        <v-list-tile-title v-else>---</v-list-tile-title>
        <v-list-tile-sub-title
          v-if="notice.employee && notice.employee.rol"
        >{{ notice.employee.rol.name }}</v-list-tile-sub-title>
        <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <!-- Publisher -->

    <!-- Event summary -->
    <eventSumary
      :notice="notice"
      v-if="notice.type == 'E'"
      v-on:parent-confirm="showParentConfirm"
      v-on:parent-attendance="showParentAttendance"
    ></eventSumary>
    <!-- Event summary -->

    <!-- Parent's reading tile -->
    <v-list-tile avatar @click="showWatchedParents">
      <v-list-tile-avatar>
        <v-icon large>remove_red_eye</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>Confirmaciones de lectura</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <!-- Parent's reading tile -->

    <!-- Attachments -->
    <v-subheader v-if="notice.files && notice.files.length>0">Documentos anexados</v-subheader>
    <div v-if="notice.files && notice.files.length>0" class="px-2">
      <v-btn
        class="ma-2 mb-3"
        rounded
        v-for="n in notice.files"
        :key="n.id"
        :href="n.fileUrl"
        target="_blank"
      >
        <v-icon left>save</v-icon>
        <strong>{{ n.name }}</strong>&nbsp;
        <span>{{ (n.size/(1024*1024)).toFixed(2)+"Mb" }}</span>&nbsp;
      </v-btn>
    </div>
    <!-- Attachments -->

    <!-- Report :: parent authorizations -->
    <parentAuthorizations :notice="notice" v-if="notice.type == 'R'"></parentAuthorizations>
    <!-- Report :: parent authorizations -->

    <v-divider></v-divider>
    <noticeAudience :notice="notice"></noticeAudience>
  </div>
</template>

<script>
import moment from "moment";
import eventSumary from "./EventSummary";
import parentAuthorizations from "./ParentAuthorizations";
import noticeAudience from "./NoticeAudience";

export default {
  components: {
    eventSumary,
    parentAuthorizations,
    noticeAudience
  },
  props: ["notice", "showDescription"],
  methods: {
    showParentConfirm() {
      this.$emit("parent-confirm");
    },
    showParentAttendance() {
      this.$emit("parent-attendance");
    },
    showWatchedParents() {
      this.$emit("parent-watched");
    }
  },
  filters: {
    dateFormat(value) {
      return moment(String(new Date(value))).format("DD/MM/YYYY");
    },
    noticeTypeFilter: function(type) {
      switch (type) {
        case "A":
          return "Aviso";
        case "E":
          return "Evento";
        case "P":
          return "Permiso";
        case "R":
          return "Reporte";
      }
    },
    confirmFilter: function(confirm) {
      switch (confirm) {
        case "A":
          return "Aprobado";
        case "P":
          return "Pendiente de autorización";
        default:
          return "No autorizado";
      }
    }
  }
};
</script>

<style>
</style>